// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Epl5","type":"styles_type__1Isph","choices":"styles_choices__1oQLk"};